export default variantHasOptionValue = ({
  variant,
  optionName,
  optionValue,
}) => {
  return variant.selectedOptions.some(
    (option) => option.name === optionName && option.value === optionValue,
  );
};
